import React from "react";
import { withRouter } from "react-router-dom";
import ClientsPage from "../multiUserManagementClients/ClientsPage";

function SubAdminsPage(props) {
  return <ClientsPage type={"sub-admin"} />;
}

export default withRouter(SubAdminsPage);
